import { initCache } from "../services/cache";
import { preloadCollections } from "../services/preload";
import { misPermisos } from "../services/permisos";
import { traerConteos } from "../services/conteos";
import { abrirSesionEnFlotaBot } from "../services/ssoFlotaBot";
import { realtime } from "../services/store";
import { FLOTABOT } from "../components/layout/secciones";

/* Aprovechar los segundos de la pantalla de carga.
 *
 * POR QUÉ. Al aceptar la contraseña arranca `iniciarRealtime()`, que se suscribe
 * a catorce colecciones. Eso siempre tardó lo que tardó; lo que pasaba es que
 * la persona lo esperaba YA ADENTRO de la app, mirando una pantalla a medio
 * armar. Y encima el caché, los permisos y los números del menú recién salían
 * después, cuando montaba el armazón.
 *
 * Ahora todo eso corre mientras se dibuja la ruta a Ushuaia. No se agrega
 * espera: se mueve la que ya existía a un momento en que hay algo para mirar.
 *
 * NADA DE ESTO PUEDE FRENAR EL INGRESO. Cada pieza se traga su propio error:
 * si los conteos fallan, el menú aparece sin números; si falla el precalentado
 * entero, la app carga como cargaba antes. Quedarse afuera porque no se pudo
 * precargar un adorno sería mucho peor que entrar sin el adorno.
 */

// Cuánto se espera como mucho. Pasado esto se entra igual y lo que falte
// termina de cargar adentro, que es exactamente lo que pasaba antes.
const TOPE_MS = 12000;

const conTope = (promesa, ms) =>
  Promise.race([promesa, new Promise((ok) => setTimeout(ok, ms))]);

const tragarse = (promesa) => promesa.catch(() => null);

/* El store de realtime avisa que terminó bajando su bandera. No expone un
 * evento, así que se lo consulta cada tanto — son unos pocos chequeos durante
 * la animación, no un bucle vivo. */
const esperarRealtime = (ms) =>
  new Promise((ok) => {
    const t0 = Date.now();
    const mirar = () => {
      if (!realtime.loading || Date.now() - t0 > ms) return ok();
      setTimeout(mirar, 120);
    };
    mirar();
  });

export const precalentar = async () => {
  const permisos = await tragarse(misPermisos()).then((p) => p || []);

  const tareas = [
    // El caché que hoy espera el armazón: empresas y sectores.
    tragarse(initCache()),
    // Las colecciones chicas que casi todas las pantallas terminan pidiendo.
    tragarse(preloadCollections()),
    // Los números del menú.
    tragarse(traerConteos()),
    // Los listados grandes, que es lo que de verdad tarda.
    esperarRealtime(TOPE_MS),
  ];

  /* Para quien tiene el mapa: se abre la sesión en FlotaBot y se calienta la
   * conexión. Es UN canje de token y un pedido de la página, no el mapa entero.
   *
   * Y no se monta el iframe de verdad a propósito, por dos razones. Una: el
   * panel vive en el armazón y no en esta pantalla, así que un iframe montado
   * acá se destruiría al entrar y el trabajo se tiraría. La otra ya está
   * escrita en PanelesFlotaBot: bajar aplicaciones enteras que nadie pidió
   * compite con la red de lo que sí se está mirando. Lo que se gana acá es lo
   * caro y reutilizable —DNS, TLS, la cookie de sesión y el HTML en caché—,
   * que es lo que hace que el primer clic al mapa no arranque de cero. */
  /* SIN CONDICIÓN, desde que el mapa dejó de llevar permiso. Antes esto miraba
   * `ver.operacion`; hoy el mapa lo abre cualquiera con sesión, así que
   * seguir preguntando por un permiso dejaría sin calentar justo a los que
   * pasaron a tenerlo — y son los que más lo notan, porque para ellos el mapa
   * es la única pantalla de FlotaBot que van a abrir. */
  tareas.push(tragarse(abrirSesionEnFlotaBot()));
  tareas.push(
    tragarse(
      fetch(`${FLOTABOT}/mapa`, { credentials: "include", mode: "no-cors" }),
    ),
  );

  await conTope(Promise.all(tareas), TOPE_MS);
  return permisos;
};
